import { axiosWeb, patchCache, version } from '../globals';

export namespace generators {
  export const getAll = async (isPublic = true) => {
    const res = await axiosWeb.get(`/source-output/data.generators.min.json?${version}`);

    if (res && res.data) {
      patchCache({ generators: res.data });
    }

    return res;
  };

  export const get = async (id: string) => {};
}
